import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/construccion.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[8];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[9].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[9].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[7].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="">
        <li>Observa esta viñeta:</li>
      </ul>
      <img src={Imagen1} className="img-fluid" alt="Peruanos" />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-0 mt-5">
            <li>
              Conversa con un compañero, compañera o familiar. ¿Es un problema
              que las casas se construyan en el cauce de los ríos? ¿Por qué?
            </li>
          </ul>
          <textarea rows={3} className="form-control" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa esta viñeta. Pida que lean en voz
            alta el diálogo propuesto en la viñeta. Aclare que el cauce es el
            camino, el lecho por el que pasa un río. Lea la segunda indicación:
            Conversa con un compañero o compañera. ¿Es un problema que las casas
            se construyan en el cauce de los ríos? ¿Por qué? Déles un tiempo
            para trabajar en parejas o con un familiar. Retome algunas respuestas y apúntelas.
            Cierre la actividad señalando los peligros de construir en el cauce
            de los ríos. Puede, por ejemplo, mencionar lo siguiente:
            <ul>
              <li>
                <i>
                  “Construir en el cauce de un río resulta peligroso. Las
                  viviendas ubicadas ahí hacen que la población sea vulnerable,
                  es decir, que esté expuesta a amenazas y que viva en un riesgo
                  permanente. En este caso, en época de lluvias, la población
                  podría estar expuesta a una inundación o también podría
                  producirse un huayco –una corriente muy violenta de agua,
                  cargada de piedras, malezas, lodo, etc., que se desplaza a lo
                  largo de un cauce–“.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
